let imageDropzone = $('div.image-dropzone')
window.imageDropzone = imageDropzone.dropzone({
    url: imageDropzone.attr('data-url'),
    autoProcessQueue: true,
    uploadMultiple: true,
    parallelUploads: 1,
    addRemoveLinks: true,
    maxFiles: 10,
    dictDefaultMessage: window.language['dropzone']['defaultMessage'],
    dictFallbackMessage: window.language['dropzone']['fallbackMessage'],
    dictFallbackText: window.language['dropzone']['fallbackText'],
    dictFileTooBig: window.language['dropzone']['fileTooBig'],
    dictInvalidFileType: window.language['dropzone']['invalidFileType'],
    dictResponseError: window.language['dropzone']['responseError'],
    dictCancelUpload: window.language['dropzone']['cancelUpload'],
    dictCancelUploadConfirmation: window.language['dropzone']['cancelUploadConfirmation'],
    dictRemoveFile: window.language['dropzone']['removeFile'],
    dictMaxFilesExceeded: window.language['dropzone']['maxFilesExceeded'],
    init: function () {
        this.on("sending", function (file, xhr, formData) {
            formData.append("form_uuid", $('#form_uuid').val());
            formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        });
    },
    error: function (file) {
        $(file.previewElement).remove();
    },
    success: function (files, response) {
        console.log(files, JSON.stringify(response));
        $(files).each(function (i, v) {
            v.previewTemplate.setAttribute('data-id', response.files[i].id);
        })
    },
    removedfile: function (file) {
        let server_file = $(file.previewTemplate);
        let id = server_file.attr("data-id");
        console.log(server_file, id);
        $.ajax({
            url: imageDropzone.attr('data-delete'),
            type: "DELETE",
            data: {"_token": $('meta[name="csrf-token"]').attr('content'), 'id': id},
            success: (data) => {
            },
            error: function (data) {
            }
        });
        server_file.remove();
    }
});


let docDropzone = $('div.doc-dropzone')
docDropzone.dropzone({
    url: docDropzone.attr('data-url'),
    autoProcessQueue: true,
    uploadMultiple: true,
    parallelUploads: 1,
    addRemoveLinks: true,
    maxFiles: 10,
    dictDefaultMessage: window.language['dropzone']['defaultMessage'],
    dictFallbackMessage: window.language['dropzone']['fallbackMessage'],
    dictFallbackText: window.language['dropzone']['fallbackText'],
    dictFileTooBig: window.language['dropzone']['fileTooBig'],
    dictInvalidFileType: window.language['dropzone']['invalidFileType'],
    dictResponseError: window.language['dropzone']['responseError'],
    dictCancelUpload: window.language['dropzone']['cancelUpload'],
    dictCancelUploadConfirmation: window.language['dropzone']['cancelUploadConfirmation'],
    dictRemoveFile: window.language['dropzone']['removeFile'],
    dictMaxFilesExceeded: window.language['dropzone']['maxFilesExceeded'],
    init: function () {
        this.on("sending", function (file, xhr, formData) {
            formData.append("form_uuid", $('#form_uuid').val());
            formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        });
    },
    error: function (file) {
        $(file.previewElement).remove();
    },
    success: function (files, response) {
        console.log(files, JSON.stringify(response));
        $(files).each(function (i, v) {
            v.previewTemplate.setAttribute('data-id', response.files[i].id);
        })
    },
    removedfile: function (file) {
        let server_file = $(file.previewTemplate);
        let id = server_file.attr("data-id");
        console.log(server_file, id);
        $.ajax({
            url: docDropzone.attr('data-delete'),
            type: "DELETE",
            data: {"_token": $('meta[name="csrf-token"]').attr('content'), 'id': id},
            success: (data) => {
            },
            error: function (data) {
            }
        });
        server_file.remove();
    }
});

let videoDropzone = $('div.video-dropzone')
videoDropzone.dropzone({
    url: videoDropzone.attr('data-url'),
    autoProcessQueue: true,
    uploadMultiple: true,
    parallelUploads: 1,
    addRemoveLinks: true,
    maxFiles: 10,
    dictDefaultMessage: window.language['dropzone']['defaultMessage'],
    dictFallbackMessage: window.language['dropzone']['fallbackMessage'],
    dictFallbackText: window.language['dropzone']['fallbackText'],
    dictFileTooBig: window.language['dropzone']['fileTooBig'],
    dictInvalidFileType: window.language['dropzone']['invalidFileType'],
    dictResponseError: window.language['dropzone']['responseError'],
    dictCancelUpload: window.language['dropzone']['cancelUpload'],
    dictCancelUploadConfirmation: window.language['dropzone']['cancelUploadConfirmation'],
    dictRemoveFile: window.language['dropzone']['removeFile'],
    dictMaxFilesExceeded: window.language['dropzone']['maxFilesExceeded'],
    init: function () {
        this.on("sending", function (file, xhr, formData) {
            formData.append("form_uuid", $('#form_uuid').val());
            formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        });
    },
    error: function (file) {
        $(file.previewElement).remove();
    },
    success: function (files, response) {
        console.log(files, JSON.stringify(response));
        $(files).each(function (i, v) {
            v.previewTemplate.setAttribute('data-id', response.files[i].id);
        })
    },
    removedfile: function (file) {
        var server_file = $(file.previewTemplate);
        var id = server_file.attr("data-id");
        console.log(server_file, id);
        $.ajax({
            url: videoDropzone.attr('data-delete'),
            type: "DELETE",
            data: {"_token": $('meta[name="csrf-token"]').attr('content'), 'id': id},
            success: (data) => {
            },
            error: function (data) {
            }
        });
        server_file.remove();
    }
});
